import React from 'react';

const TYPE_STYLES = {
    error: {
        background: '#fdecee',
        border: '1px solid #f1b9c0',
        color: '#80222c'
    },
    info: {
        background: '#eef4ff',
        border: '1px solid #bfd3ff',
        color: '#1f4c8f'
    },
    warning: {
        background: '#fff6e5',
        border: '1px solid #ffd591',
        color: '#8a5a00'
    }
};

/**
 * Lightweight replacement for Atlaskit InlineMessage.
 *
 * @param {Object} props - Component props.
 * @param {React$Node} props.children - Message content.
 * @param {string} props.title - Message title.
 * @param {string} props.type - Visual type.
 * @returns {React$Node}
 */
export default function InlineMessage({ children, title, type = 'info' }) {
    const typeStyle = TYPE_STYLES[type] || TYPE_STYLES.info;

    return (
        <div
            style = {{
                ...typeStyle,
                borderRadius: '8px',
                padding: '12px 14px'
            }}>
            {title ? (
                <div
                    style = {{ fontSize: '14px',
                        fontWeight: 700,
                        marginBottom: '6px' }}>
                    {title}
                </div>
            ) : null}
            <div
                style = {{ fontSize: '13px',
                    lineHeight: 1.5 }}>
                {children}
            </div>
        </div>
    );
}
